// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-header_root__o3qAx"};